import React from 'react'
import EPMRDetailsDialog from './Dialog'

const EpmrValidation = ({epmrReceiptDetails}) => {
   if(!epmrReceiptDetails) return ''
  return (
      <EPMRDetailsDialog epmrReceiptDetails = {epmrReceiptDetails}/>
  )
}

export default EpmrValidation